import * as React from 'react';

import { translate } from '~l10n/client';

import { PauseIcon } from './Icons/PauseIcon';

export function ActivityPausedView() {
  return (
    <div className="waiting-for-teacher-container">
      <div className="waiting-inside-container">
        <div className="pause-icon-container">
          <PauseIcon />
        </div>
        <div className="waiting-text">
          <p className="waiting-for-activity-text">
            {translate('Activity Paused')}
          </p>
        </div>
      </div>
    </div>
  );
}
